import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SharedIssueBaseState} from "@shared/components/issues/store/shared-issue-base.state";
import {IssueContentType, IssueType, ResourceProfileIssueTemplateShortCutDto} from "@server-models";

export const sharedIssueBaseStoreSelect = createFeatureSelector<SharedIssueBaseState>('issues');


export const selectIsLoading = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.isLoading
);

export const selectIsSubmitLoading = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.isSubmitLoading
);

export const selectIssueList = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.issueList.items
);

export const selectIssueListPaging = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.issueList.paging
);

export const selectIssueTemplateListPaging = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.issueTemplateList.paging
);

export const selectPageLoading = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.isLoading
);

export const selectPageLoadingId = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.isLoadingId
);

export const selectIssueTemplateList = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.issueTemplateList.items
);

export const selectCurrentPreview = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.currentIssueTemplate
);

export const selectCurrentPreviewId = createSelector(
  selectCurrentPreview,
  (state: { templateId: number, contentType: IssueContentType }) => state.templateId
);

export const selectCurrentPreviewIssueType = createSelector(
  selectCurrentPreview,
  (state: { templateId: number, contentType: IssueContentType }) => state.contentType
);


export const selectCurrentIssueMetaInfo = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.currentIssueMetaInfo
);

export const selectCurrentIssueId = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.currentIssueMetaInfo.issueId
);

export const selectCurrentIssueType = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.currentIssueMetaInfo.issueType
);

export const selectCurrentIssue = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.currentIssue
);

export const selectDetailDataFormatted = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.detailDataFormatted
);

export const selectSelectedPicture = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.selectedPicture
);

export const selectSelectedPictureIsLoading = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.selectedPictureIsLoading
);

export const selectSelectedPictureIsLoadingId = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.selectedPictureIsLoadingId
);

export const selectSelectedPictureAsBlob = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.selectedPictureAsBlob
);

export const selectSelectedSignatureAsBlob = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.selectedSignatureAsBlob
);

export const selectSelectedSignatureIsLoading = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.selectedSignatureIsLoading
);

export const selectSelectedSignatureIsLoadingId = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.selectedSignatureIsLoadingId
);

export const selectSavedFile = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.savedFile
);

export const selectSavedSignature = createSelector(
  sharedIssueBaseStoreSelect,
  (state: SharedIssueBaseState) => state.savedSignature
);
